export type MemesSort = 'hot' | 'recent' | 'top' | 'top_new'
export type MemeTopWindow = '1h' | '24h' | 'week' | 'month' | 'year'

// The memes discovery panel stores the shared StreamOrder vocabulary in
// filter.order. Translate it only at the /api/v1/memes boundary.
export const memeSortFromOrder = (order?: string | null): MemesSort => {
    switch (order) {
        case 'time':
        case 'recent':
            return 'recent'
        case 'upvalue':
        case 'upvote':
        case 'top':
            return 'top'
        case 'top_new':
            return 'top_new'
        case 'upvalueTrending':
        case 'upvoteTrending':
        case 'hot':
            return 'hot'
        default:
            return 'recent'
    }
}

export const memeOrderParams = (
    order?: string | null,
    topWindow?: MemeTopWindow | null,
): { sort: MemesSort; topWindow?: MemeTopWindow } => {
    const sort = memeSortFromOrder(order)
    return sort === 'top' && topWindow ? { sort, topWindow } : { sort }
}

export const getMemesQueryKey = (
    sort: MemesSort,
    topWindow?: MemeTopWindow,
    embed = true,
    scope?: 'mine',
) => ['memes', sort, topWindow || 'all', embed, scope || 'public'] as const
